import React from 'react';
import { Text } from '@leverege/ui-elements';
import { contractStates } from '../../../constants';
import { jsx as _jsx } from "react/jsx-runtime";
const VARIANTS = {
  [contractStates.archived]: 'pill',
  [contractStates.active]: 'pillSuccess|pill',
  [contractStates.scheduled]: 'pillPrimary|pillBlue|pill'
};
const LABELS = {
  [contractStates.archived]: 'Archived',
  [contractStates.active]: 'Active',
  [contractStates.scheduled]: 'Scheduled'
};
export default function ContractState(props) {
  const {
    value,
    defaultValue = '---'
  } = props;
  if (typeof value !== 'string' || !value) {
    return defaultValue;
  }
  return /*#__PURE__*/_jsx(Text, {
    variant: VARIANTS[value] || 'pill',
    children: LABELS[value] || value
  });
}